const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res, fallbackMessage) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) throw new Error(payload?.error || fallbackMessage);
  return payload;
}

export async function getQuestions({ courseId, userId } = {}) {
  const params = new URLSearchParams();
  if (courseId) params.set('courseId', courseId);
  if (userId) params.set('userId', userId);
  const res = await fetch(`${apiBase}/api/questions?${params}`);
  return handleResponse(res, 'Unable to load questions.');
}

export async function submitAttempts({ userId, sessionId, answers }) {
  const res = await fetch(`${apiBase}/api/quiz-attempts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, sessionId, answers }),
  });
  return handleResponse(res, 'Unable to save quiz attempts.');
}

export async function getTopicStats({ userId, courseId } = {}) {
  const params = new URLSearchParams();
  if (userId) params.set('userId', userId);
  if (courseId) params.set('courseId', courseId);
  const res = await fetch(`${apiBase}/api/quiz-attempts/stats?${params}`);
  return handleResponse(res, 'Unable to load topic stats.');
}

export async function getSessions({ userId } = {}) {
  const params = new URLSearchParams();
  if (userId) params.set('userId', userId);
  const res = await fetch(`${apiBase}/api/quiz-attempts/sessions?${params}`);
  return handleResponse(res, 'Unable to load sessions.');
}

export async function getSessionReplay(sessionId, userId) {
  const params = new URLSearchParams({ userId });
  const res = await fetch(`${apiBase}/api/quiz-attempts/session/${encodeURIComponent(sessionId)}?${params}`);
  return handleResponse(res, 'Unable to load session replay.');
}
